import { render, staticRenderFns } from "./viewNews.vue?vue&type=template&id=1d3feff9&"
import script from "./viewNews.vue?vue&type=script&lang=js&"
export * from "./viewNews.vue?vue&type=script&lang=js&"
import style0 from "./viewNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports